import $ from "jquery";
import _ from "underscore";
import TemplateView from "../../TemplateView";
import LoadingControlMixin from "../LoadingControlMixin";
import messageResource from "../../messageResource"

export default class DeadlineEditor extends TemplateView {
    constructor($containerEl, editable, onDeadlineChangedCb = () => {}) {
        super($containerEl);
        this.updateOnInit = true;
        this.onDeadlineChangedCb = onDeadlineChangedCb

        this.state = {
            editable: editable,
        }

        this.onStatePropertyChanged('editable', editable => this.setEditable(editable))
    }

    templateHtml() {
        return "<div class='deadlineEditor'>" +
               // No EOL because we need remove whitespace in HTML code (inline-block)
               "<span class='value'></span><span class='na'></span><span class='icon'>&nbsp;</span>" +
               "</div>"
    }

    afterRender() {
        this.deadline = null;
        this.disabled = false;
        this.$value = this.find(".value");
        this.$el.toggleClass('editable', this.state.editable);
        this.$placeholder = this.$el.find('.na')
        this._updatePlaceholderText()
        this.deadlinePickerMenu = this.getDataPickerMenu();
        if (this.deadlinePickerMenu) {
            this._subscribeClickEvent();
        }
    }

    update() {
        this.$value.text(this.deadline ? this.formatDate() : "");
        this.$el.toggleClass("noDeadline", !this.deadline);
        this.$el.toggleClass("deadlinePassed", !!this.isDeadlinePassed);
        this.$el.toggleClass("deadlineUpcoming", !!this.isDeadlineUpcoming);
        this.$el.toggleClass("disabled", this.disabled);
        this.$el.toggleClass('editable', this.state.editable);
    }

    formatDate() {
        return this.deadline.format(this.dateFormat)
    }

    getDeadline() {
        return this.deadline;
    }

    setDeadline(deadline) {
        this.deadline = deadline;
        const currentDate = window.currentUserTime().clearTime().getTime();
        this.isDeadlinePassed = !!this.deadline && currentDate > this.deadline.getTime();
        this.isDeadlineUpcoming = !!this.deadline && currentDate >= this.deadline.getNDaysBefore(3).clearTime() && currentDate <= this.deadline.getTime();
        this.update();
    }

    setDateFormat(dateFormat) {
        this.dateFormat = dateFormat;
    }

    setEditable(editable) {
        this.state.editable = editable;
        this._updatePlaceholderText()
        this.update()
    }

    _updatePlaceholderText() {
        this.$placeholder.text(this.state.editable ?
                                 messageResource.getMessage('task.time_editor_placeholder.set_up_deadline') :
                                 messageResource.getMessage('task.time_editor_placeholder.not_defined'))
    }

    isDisabled() {
        return this.disabled;
    }

    setDisabled(disabled) {
        this.disabled = disabled;
        this.update();
    }

    disableAndHide() {
        this.setDisabled(true);
        this.getDataPickerMenu().hide();
    }


    getDataPickerMenu() {
        return this.deadlinePickerMenu;
    }

    setDataPickerMenu(menu) {
        this.deadlinePickerMenu = menu;
        this._subscribeClickEvent();
    }

    _subscribeClickEvent() {
        const self = this;
        this.bindClick(function() {
            if (!self.state.editable || self.state.disabled || this.isLoading())
                return;

            self.$el.addClass("pressed");
            self.deadlinePickerMenu.setValue(self.deadline || new Date());
            self.deadlinePickerMenu.showAt(self.$el,
                function(date) {
                    self.$el.removeClass("pressed");
                    if (self.deadline && date && self.deadline.getTime() !== date.getTime() ||
                        !!self.deadline !== !!date) {
                        self.setDeadline(date);
                        self.update();
                        $(self).trigger("change", date);
                        self.onDeadlineChangedCb(date)
                    }
                },
                function() {
                    self.$el.removeClass("pressed");
                });
        });

    }

    _currentTime() {
        const date = new Date();
        return date.getTime();
    }
}

_.extend(DeadlineEditor.prototype, LoadingControlMixin);


// WEBPACK FOOTER //
// ./web/js/controls/task/DeadlineEditor.js